import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onbording-layout',
  templateUrl: './onbording-layout.component.html',
  styleUrls: ['./onbording-layout.component.scss']
})
export class OnbordingLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
